module.exports = __webpack_public_path__ + "static/img/1神州.b1a384c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/1神州.jpg
// module id = HoWs
// module chunks = 1